<header id="header" class="header d-flex align-items-center">
  <div class="d-flex align-items-center justify-content-between logo-bar">
    <!-- <i class="bi bi-list toggle-sidebar-btn" (click)="toogleOpened()"></i> -->
    <i class="toggle-sidebar-btn" [ngClass]="{'bi-chevron-left': !isSidebarOpened, 'bi-chevron-right': isSidebarOpened}" (click)="toogleOpened()"></i>

    <a class="logo">
      <img src="assets/img/logo-naranja.png" alt="" />
      <!-- <span class="d-none d-lg-block">HAYLLI REST</span> -->
    </a>
    <!-- <div class="utilities container">
      <div class="row">
        <div class="col-sm">
          <a href=""><i class="bi bi-cash-coin"></i></a>
        </div>
        <div class="col-sm">
          <a href=""><i class="bi bi-file-earmark-text"></i></a>
        </div>
        <div class="col-sm">
          <a href=""><i class="bi bi-file-earmark"></i></a>
        </div>
        <div class="col-sm">
          <a href=""><i class="bi bi-cart3"></i></a>
        </div>
      </div>
    </div> -->
  </div>
  <!-- End Logo -->
  <nav class="header-nav ms-auto">
    <ul class="d-flex align-items-center">
      <!-- <li class="nav-item d-block d-lg-none">
        <a class="nav-link nav-icon search-bar-toggle" href="#">
          <i class="bi bi-search"></i>
        </a>
      </li> -->
      <!-- End Search Icon-->

      <li class="nav-item support-style">
        <div class="support-style__div wtsp-clickable" (click)="goToWtsp()"><p>Soporte +51 938 648 117</p></div>
      </li>

      <li class="nav-item">
        <div>
          <img src="assets/icon/notification-bing.svg" alt="Reservation" />
        </div>
      </li>

      <li class="nav-item dropdown pe-3 dd-profile" #dropdown>
        <a class="nav-link nav-profile d-flex align-items-center" href="#" (click)="toggleDropdown($event)">
          <div class="nav-profile__style">
            <h5 class="ps-2">{{userRole}}</h5>
            <span>{{ useEmail }}</span>
          </div>
          <div>
            <img src="assets/img/profile-img.jpg" alt="Profile" class="rounded-circle" />
          </div>
        </a>

        <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile" [ngClass]="{ 'show': isDropdownOpen }" (click)="preventClosing($event)">
          <li>
            <a class="dropdown-item d-flex align-items-center" style="cursor: pointer" (click)="showPop(); closeDropdown()">
              <i class="bi bi-person"></i>
              <span>Mi Perfil</span>
            </a>
          </li>
          <li>
            <hr class="dropdown-divider" />
          </li>
          <li>
            <a class="dropdown-item d-flex align-items-center" style="cursor: pointer" (click)="logOut(); closeDropdown()">
              <i class="bi bi-box-arrow-right"></i>
              <span>Cerrar Sesión</span>
            </a>
          </li>
        </ul>

      </li>


      <!-- End Profile Nav -->
    </ul>
    <div class="modal" tabindex="-1" role="dialog" [ngClass]="{ 'd-block': showPopup }">
      <div class="modal-dialog" role="document">
        <div class="modal-content info-modal">
          <div class="modal-header" style="background: rgba(255, 154, 35, 0.80)">
            <h5 class="modal-title text-white">Información del Usuario</h5>
          </div>
          <div class="modal-body">
            <div class="container-fluid">
              <div class="row">
                <div class="col-6">
                  <p>Nombre:</p>
                  <p>Apellido:</p>
                  <p>Correo:</p>
                  <p>Ruc:</p>
                  <p>Razón social:</p>
                </div>
                <div class="col-6">
                  <p>{{ UserName }}</p>
                  <p>{{ UseLastName }}</p>
                  <p>{{ useEmail }}</p>
                  <p>{{ rucCompany }}</p>
                  <p>{{ RazCompany }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" style="background: rgba(255, 154, 35, 0.80)" data-dismiss="modal" class="btn text-white" (click)="closePopup()">Aceptar</button>
          </div>
        </div>
      </div>
    </div>
  </nav>
  <!-- End Icons Navigation -->
</header>
<!-- End Header -->
